// src/pages/PricingPage.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import useAuthStore from "../../stores/authStore"; // <-- assuming you store auth here
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import PricingSection from "../../components/PricingSection/PricingSection";
import "./PricingPage.css";

const PricingPage = () => {
  const { user } = useAuthStore();
  const navigate = useNavigate();

  const isAuthenticated = !!user;

  useEffect(() => {
    document.title = "Pricing | Brandly";
  }, []);

  return (
    <div className="Pricing-wrapper">
      {isAuthenticated ? (
        <div className="pricing-header">
          <button
            className="back-to-dashboard-btn"
            onClick={() => navigate("/dashboard")}
          >
            ← Back to Dashboard
          </button>
        </div>

      ) : (
        <Navbar />
      )}

      <PricingSection />

      {!isAuthenticated && <Footer />}
    </div>
  );
};

export default PricingPage;
